<template>
  <!-- 操作记录 -->
  <div class="operation-class">
    <el-form>
      <el-row type="flex" justify="left" style="flex-wrap: wrap;align-items: end">
        <el-col :span="7">
          <!--操作时间-->
          <el-form-item :label="$t('GlobalSetObj.operationTime')">
            <el-date-picker
              v-model="operationTimeValue"
              :clearable="false"
              :default-time="['00:00:00', '23:59:59']"
              :placeholder="$t('newOrder.SelectDatetime')"
              range-separator="~"
              style="width: 95%"
              size="small"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="operationTimeChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 操作人 -->
          <el-form-item :label="$t('collectionCenter.operator')">
            <el-select
              v-model="opQuery.params.operatorId"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              size="small"
              clearable
              filterable
              style="width: 95%"
              remote
              reserve-keyword
              :remote-method="getAllUser"
              @clear="getAllUser"
            >
              <el-option
                v-for="(item, idx) in allUserList"
                :key="idx"
                :label="item.realName + '（' + item.username + '）'"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 操作页面 -->
          <el-form-item :label="$t('collectionCenter.operationPage')">
            <el-select
              v-model="opQuery.params.businessType"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              size="small"
              clearable
              filterable
              style="width: 95%"
            >
              <el-option
                v-for="(item, idx) in businessTypeList"
                :key="idx"
                :label="item.label" :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 操作对象 -->
          <el-form-item :label="$t('collectionCenter.operatedObject')">
            <el-input
              v-model="opQuery.params.businessName"
              :placeholder="$t('collectionCenter.pleaseInput')"
              clearable
              size="small"
              style="width: 95%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 操作类型 -->
          <el-form-item :label="$t('collectionCenter.operationType')">
            <el-select
              v-model="opQuery.params.operationType"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              clearable
              size="small"
              style="width: 95%"
            >
              <el-option label="新增（Adicionar）" value="ADD" />
              <el-option label="修改（Alterar）" value="UPDATE" />
              <el-option label="删除（Excluir）" value="DELETE" />
              <el-option label="启用（Ativar）" value="ENABLE" />
              <el-option label="停用（Desativar）" value="DISABLE" />
              <el-option label="授权（Autorizar）" value="AUTHORIZE" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <div style="margin-bottom: 4px">
            <el-button
              size="mini"
              type="primary"
              @click="operationSearch"
            >{{ $t('newOrder.search') }} </el-button><!-- 搜索 -->
            <el-button
              size="mini"
              @click="operationReset"
            >{{ $t('collectionCenter.reset') }} </el-button><!-- 重置 -->
          </div>
        </el-col>
      </el-row>
    </el-form>
    <el-table
      ref="tableRef"
      size="small" max-height="600" border
      style="width: 100%;margin-top: 20px"
      :header-cell-style="{background: '#e1e1e1', color: '#000', 'font-size': '15px'}"
      :data="operationTableData"
    >
      <el-table-column :label="$t('operationCenter.ind')" width="60" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.idx }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="operationTime"
        align="center"
        :label="$t('GlobalSetObj.operationTime')"
      /><!-- 操作时间 -->
      <el-table-column
        prop="operatorName"
        align="center"
        :label="$t('collectionCenter.operator')"
      /><!-- 操作人 -->
      <el-table-column
        prop="businessType"
        align="center"
        :label="$t('collectionCenter.operationPage')"
      /><!-- 操作页面 -->
      <el-table-column
        prop="operationTypeDesc"
        align="center"
        :label="$t('collectionCenter.operationButton')"
      /><!-- 操作按钮 -->
      <el-table-column
        prop="businessName"
        align="center"
        :label="$t('collectionCenter.operatedObject')"
      /><!-- 操作对象 -->
      <el-table-column
        prop="changeInfo"
        align="center"
        :label="$t('collectionCenter.changeInfo')"
      /><!-- 变更信息 -->
      <el-table-column
        align="center"
        :label="$t('operationCenter.operate')"
        width="100"
      >
        <template slot-scope="scope">
          <span
            v-if="(scope.row.oldData && Object.keys(scope.row.oldData).length > 0) ||
              (scope.row.newData && Object.keys(scope.row.newData).length > 0)"
            class="detail-toggle" @click="toggleExpand(scope.row)"
          >
            {{ $t('collectionCenter.detail') }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <div class="right">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="opQuery.pageNumber"
        :page-sizes="[10, 20, 50, 100, 500, 1000]"
        :page-size.sync="opQuery.pageSize"
        :total="operationTotal"
        background
        style="margin: 10px 0"
        @current-change="operationSearch1"
        @size-change="operationSearch"
      />
    </div>

    <!-- 详情弹框 -->
    <el-dialog
      :title="$t('collectionCenter.operationDetails')"
      :visible.sync="detailVisible"
      width="50%"
    >
      <div v-if="dialogList.ispms">
        <el-table
          :data="dialogList.permissionList"
          style="width: 100%" border
          :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
          max-height="500" size="small"
        >
          <el-table-column prop="pmsName" :label="$t('collectionCenter.pmsName')" align="center" />
          <el-table-column prop="msg" :label="$t('collectionCenter.msg')" align="center" />
          <el-table-column prop="op" :label="$t('collectionCenter.op')" align="center" />
        </el-table>
      </div>
      <div v-else>
        <el-table
          :data="dialogList.otherList"
          style="width: 100%" border
          :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
          max-height="500" size="small"
        >
          <el-table-column prop="valName" :label="$t('collectionCenter.field')" align="center" />
          <el-table-column prop="oldValue" :label="$t('receivablePayable.BeforeOperation')" align="center" />
          <el-table-column prop="newValue" :label="$t('receivablePayable.AfterTheOperation')" align="center" />
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose">{{ $t('collectionCenter.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSiteLogs
} from '@/api/lanshou';
import dayjs from 'dayjs';
import { getUserPage } from '@/api/user.js';

export default {
  name: 'OperationalLogs',
  data() {
    return {
      dialogList: {
        ispms: false,
        permissionList: [],
        otherList: []
      },
      detailVisible: false,
      businessTypeList: [
        { label: '网点管理（Ponto de rede）', value: 'SITE' },
        { label: '客户列表（Lista de clientes）', value: 'CUSTOMER' },
        { label: '投诉工单（Ordem de serviço de reclamações）', value: 'COMPLAINT_WORK_ORDER' },
        { label: '客户时效管理（Prazo do cliente）', value: 'CUSTOMER_AGING' },
        { label: '签收限制配置（Configuração de Restrição de Assinatura）', value: 'SIGN_CONFIG' },
        { label: 'LM损失定责（Responsabilidade por perdas LM）', value: 'LM_LOSS_RESPONSIBILITY' },
        { label: '员工管理（Gestão de funcionários）', value: 'USER' },
        { label: '班次管理（Gestão de turnos）', value: 'DEPARTURE_SCHEDULE' },
        { label: '时效管理（Gestão de tempo de transferência）', value: 'TIMELINESS_TRANSFER' },
        { label: '干支线流向管理（Gestão de Fluxo de Linhas Tronco e Ramais）', value: 'BRANCH_LINE_DIRECT' }
      ],
      operationTotal: 0,
      operationTableData: [],
      opQuery: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          startTime: '',
          endTime: '',
          operatorId: '',
          businessName: '',
          operationType: '',
          businessType: ''
        }
      },
      operationTimeValue: [],
      allUserList: []
    };
  },
  created() {
    this.operationReset();
    this.getAllUser('');
  },
  methods: {
    getAllUser(name) {
      const query = {
        pageNumber: 1,
        pageSize: 10,
        params: {
          accountState: '',
          realName: name
        }
      };
      getUserPage(query, false).then((res) => {
        if (res.code === 200) {
          this.allUserList = res.data.records;
        }
      });
    },
    toggleExpand(row) {
      // 改为弹框展示
      const ispms = row.operationType === 'AUTHORIZE';
      let permissionList = [];
      const otherList = [];
      let combinedData = []; // 合并 newData 和 oldData
      if (ispms) {
        if (row.newData && Object.keys(row.newData).length > 0) {
          combinedData = combinedData.concat(Object.values(row.newData));
        }
        if (row.oldData && Object.keys(row.oldData).length > 0) {
          combinedData = combinedData.concat(Object.values(row.oldData));
        }
        if (combinedData.length <= 0) return;
        // 授权情况
        combinedData.forEach(item => {
          permissionList = item.map(obj => {
            const pmsList = {};
            for (const [key, value] of Object.entries(obj)) {
              if (this.$t('collectionCenter.op') === key) {
                pmsList.op = value;
              } else if (this.$t('collectionCenter.msg') === key) {
                pmsList.msg = value;
              } else if (this.$t('collectionCenter.pmsName') === key) {
                pmsList.pmsName = value;
              } else {
                pmsList[key] = value;
              }
            }
            return pmsList;
          });
        });
      }
      if (!ispms) {
        // 非权限情况时
        // 区分属性名属性值就可以
        if (row.newData && Object.keys(row.newData).length > 0) {
          Object.entries(row.newData).forEach(([key, value]) => {
            otherList.push({
              field: key,
              valName: key,
              oldValue: row.oldData && row.oldData[key] ? row.oldData[key][0] : '',
              newValue: Array.isArray(value) ? value[0] : value
            });
          });
        }
        if (row.oldData && Object.keys(row.oldData).length > 0) {
          Object.entries(row.oldData).forEach(([key, value]) => {
            // eslint-disable-next-line no-prototype-builtins
            if (!row.newData || !row.newData.hasOwnProperty(key)) {
              otherList.push({
                field: key,
                valName: key,
                oldValue: Array.isArray(value) ? value[0] : value,
                newValue: ''
              });
            }
          });
        }
      }
      this.dialogList = {
        ispms,
        permissionList,
        otherList
      };
      this.detailVisible = true;
    },
    handleClose() {
      this.detailVisible = false;
    },
    operationTimeChange(val) {
      if (val === null) {
        this.operationTimeValue = [];
        this.opQuery.params.startTime = '';
        this.opQuery.params.endTime = '';
        return;
      }
      this.opQuery.params.startTime = val[0];
      this.opQuery.params.endTime = val[1];
    },
    operationSearch1() {
      getSiteLogs(this.opQuery).then(res => {
        if (res.code === 200) {
          this.operationTotal = res.data.total;
          this.operationTableData = res.data.records.map((item, indx) => {
            const formatData = (data) => {
              if (!data) return [];
              return Object.keys(data).reduce((acc, key) => {
                let value = data[key];
                if (!Array.isArray(value)) {
                  value = [value];
                }
                acc[key] = value;
                return acc;
              }, {});
            };
            const idx = (this.opQuery.pageNumber - 1) * this.opQuery.pageSize + indx + 1;
            return {
              idx,
              ...item,
              newData: formatData(item.newData),
              oldData: formatData(item.oldData)
            };
          });
        }
      });
    },
    operationSearch() {
      this.opQuery.pageNumber = 1;
      this.operationSearch1();
    },
    operationReset() {
      const d = new Date();
      const today = dayjs(d).format('YYYY-MM-DD');
      // const day = dayjs(d).subtract(7, 'day').format('YYYY-MM-DD 00:00:00');
      this.operationTimeValue = [today + ' 00:00:00', today + ' 23:59:59'];
      this.opQuery = {
        pageNumber: 1,
        pageSize: 10,
        params: {
          startTime: today + ' 00:00:00',
          endTime: today + ' 23:59:59',
          operatorId: '',
          businessName: '',
          operationType: '',
          businessType: ''
        }
      };
      this.operationSearch();
    }
  }
};
</script>

<style lang="scss" scoped>
.right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.operation-class {
  margin: 20px;
}
.operation-class ::v-deep .el-form-item {
  margin-bottom: 0 !important;
}

.detail-toggle {
  color: #409eff;
  cursor: pointer;
  user-select: none;
}
.detail-toggle:hover {
  color: #66b1ff;
}
</style>
